import React, { Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';

//<-- *Log component, import chip, chipStyles
import Chip from '@material-ui/core/Chip';
import { ChipLabels } from './../../fragments/LabelPicker';
import { chipStyles } from './../../../styles/globalStyles/dataDisplayStyles';

// import utils
import { logger, formatDatetime } from './../../../utils/utils';

// *Log component, issueModes object
const issueModes = {
  issueCreate: { mode: 'issueCreate', name: 'แจ้งเหตุละเมิด' },
  issueEditTitle: { mode: 'issueEditTitle', name: 'แก้ไขเรื่องเหตุละเมิด' },
  issueEditDetail: {
    mode: 'issueEditDetail',
    name: 'แก้ไขรายละเอียดเหตุละเมิด',
  },
  issueEditContract: {
    mode: 'issueEditContract',
    name: 'แก้ไขข้อมูลการติดต่อเพิ่มเติม',
  },
  issueTransfer: { mode: 'issueTransfer', name: 'ส่งต่อเหตุละเมิด' },
  issueStatusSet: { mode: 'issueStatusSet', name: 'ปรับปรุงสถานะเหตุละเมิด' },
  processStatusSet: {
    mode: 'processStatusSet',
    name: 'ปรับปรุงสถานะดำเนินการ',
  },
  issueLabelSet: { mode: 'issueLabelSet', name: 'ปรับปรุงป้ายกำกับ' },
  issueDimensionSet: { mode: 'issueDimensionSet', name: 'ปรับปรุงตัวชี้วัด' },
  issueCommentCreate: { mode: 'issueCommentCreate', name: 'เพิ่มความคิดเห็น' },
  issueCommentEdit: { mode: 'issueCommentEdit', name: 'แก้ไขความคิดเห็น' },
  addObserver: { mode: 'addObserver', name: 'ติดตาม' },
  removeObserver: { mode: 'removeObserver', name: 'เลิกติดตาม' },
  voteSet: { mode: 'voteSet', name: 'โหวด' },
};

// *Log component, transformIssueMode()
const transformIssueMode = (issueMode) => {
  if (issueModes.hasOwnProperty(issueMode)) {
    return issueModes[issueMode].name;
  } else {
    return 'อื่นๆ';
  }
};

const styles = (theme) => ({
  // *Log component, chipStyles()
  ...chipStyles(theme),
});

const LogCard = React.memo(({ logs, classes }) => {
  logger('LogCard reder');

  return (
    <div align="left">
      {logs.map((log) => {
        let issueLogsContext = log.issueLogs.context
          ? JSON.parse(log.issueLogs.context)
          : {};
        log.issueLogs.mode === 'issueDimensionSet' &&
          logger({ issueLogsContext });
        return (
          <div>
            <Typography variant="subtitle2" component="div" color="textPrimary">
              {/* Flexbox style */}
              <Box
                display="flex"
                flexWrap="wrap"
                bgcolor="background.paper"
                css={{ maxWidth: '100%', padding: 5 }}
              >
                {log.issueLogsCreateBy && (
                  <Box pt={1} pr={1}>
                    {`${log.issueLogsCreateBy.firstName} ${log.issueLogsCreateBy.lastName}`}
                  </Box>
                )}

                {/* Component in array joining: https://stackoverflow.com/questions/34034038/how-to-render-react-components-by-using-map-and-join/54381375 */}
                {log.issueLogs && (
                  <Fragment>
                    {log.issueLogs.mode && (
                      <Box pt={1} pr={1}>
                        {transformIssueMode(log.issueLogs.mode)}
                      </Box>
                    )}
                    <Box pt={1} pr={1}>
                      {log.issueLogs.mode === issueModes.issueCreate.mode && (
                        <Fragment>เรื่อง: {issueLogsContext.summary}</Fragment>
                      )}
                      {log.issueLogs.mode === issueModes.addObserver.mode && (
                        <Fragment>
                          {[
                            // <strong>ตำแหน่ง</strong>,
                            // issueLogsContext.position,
                            // <strong>ส่วนงาน</strong>,
                            // issueLogsContext.department,
                            <strong>ในฐานะ</strong>,
                            issueLogsContext.type === 'Subscribe' ? 'ทั่วไป (Subscribe)' : 'คณะทำงาน (Worker)',
                          ].reduce((prev, curr) => [prev, ' ', curr])}
                        </Fragment>
                      )}
                      {log.issueLogs.mode ===
                        issueModes.removeObserver.mode && (
                        <Fragment>
                          {[
                            // <strong>ตำแหน่ง</strong>,
                            // issueLogsContext.position,
                            // <strong>ส่วนงาน</strong>,
                            // issueLogsContext.department,
                            [
                              '(ในฐานะ ',
                              issueLogsContext.type === 'Subscribe'
                                ? 'ทั่วไป (Subscribe)'
                                : 'คณะทำงาน (Worker)',
                              ')',
                            ].join(''),
                          ].reduce((prev, curr) => [prev, ' ', curr])}
                        </Fragment>
                      )}
                      {log.issueLogs.mode ===
                        issueModes.issueEditTitle.mode && (
                        <Fragment>
                          {[
                            ...(issueLogsContext.before
                              ? [
                                  <strong>จาก</strong>,
                                  issueLogsContext.before.title,
                                ]
                              : ['']),
                            ...(issueLogsContext.after
                              ? [
                                  <strong>เป็น</strong>,
                                  issueLogsContext.after.title,
                                ]
                              : ['']),
                          ].reduce((prev, curr) => [prev, ' ', curr])}
                        </Fragment>
                      )}
                      {log.issueLogs.mode ===
                        issueModes.issueEditDetail.mode && (
                        <Fragment>
                          {[
                            ...(issueLogsContext.before
                              ? [
                                  <strong>จาก</strong>,
                                  issueLogsContext.before.detail,
                                ]
                              : ['']),
                            ...(issueLogsContext.after
                              ? [
                                  <strong>เป็น</strong>,
                                  issueLogsContext.after.detail,
                                ]
                              : ['']),
                          ].reduce((prev, curr) => [prev, ' ', curr])}
                        </Fragment>
                      )}
                      {log.issueLogs.mode ===
                        issueModes.issueEditContract.mode && (
                        <Fragment>
                          {[
                            ...(issueLogsContext.before
                              ? [
                                  <strong>จาก</strong>,
                                  issueLogsContext.before.contract,
                                ]
                              : ['']),
                            ...(issueLogsContext.after
                              ? [
                                  <strong>เป็น</strong>,
                                  issueLogsContext.after.contract,
                                ]
                              : ['']),
                          ].reduce((prev, curr) => [prev, ' ', curr])}
                        </Fragment>
                      )}
                      {log.issueLogs.mode === issueModes.issueTransfer.mode && (
                        <Fragment>
                          {[
                            ...(issueLogsContext.before
                              ? [
                                  <strong>จาก</strong>,
                                  `ประเภท: ${issueLogsContext.before.category.name}`,
                                  `, ระดับ: ${issueLogsContext.before.level}`,
                                  issueLogsContext.before.permissionGroup
                                    ? `, กลุ่ม: ${issueLogsContext.before.permissionGroup.name}`
                                    : '',
                                ]
                              : ['']),
                            ...(issueLogsContext.after
                              ? [
                                  <strong>เป็น</strong>,
                                  `ประเภท: ${issueLogsContext.after.category.name}`,
                                  `, ระดับ: ${issueLogsContext.after.level}`,
                                  issueLogsContext.after.permissionGroup
                                    ? `, กลุ่ม: ${issueLogsContext.after.permissionGroup.name}`
                                    : '',
                                ]
                              : ['']),
                          ].reduce((prev, curr) => [prev, ' ', curr])}
                        </Fragment>
                      )}
                      {log.issueLogs.mode === issueModes.voteSet.mode && (
                        <Fragment>
                          {[
                            ...(issueLogsContext
                              ? [
                                  issueLogsContext.vote == 1
                                    ? 'พึงพอใจ'
                                    : 'ไม่พึงพอใจ',
                                ]
                              : ['']),
                          ].reduce((prev, curr) => [prev, ' ', curr])}
                        </Fragment>
                      )}
                      {log.issueLogs.mode ===
                        issueModes.issueStatusSet.mode && (
                        <Fragment>
                          {[
                            ...(issueLogsContext.before
                              ? [
                                  <strong>จาก</strong>,
                                  <Chip
                                    className={classes.chipLabelSmallStyle}
                                    label={issueLogsContext.before.name}
                                    style={JSON.parse(
                                      issueLogsContext.before.style
                                    )}
                                  />,
                                ]
                              : ['']),
                            ,
                            ...(issueLogsContext.after
                              ? [
                                  <strong>เป็น</strong>,
                                  <Chip
                                    className={classes.chipLabelSmallStyle}
                                    label={issueLogsContext.after.name}
                                    style={JSON.parse(
                                      issueLogsContext.after.style
                                    )}
                                  />,
                                ]
                              : ['n/a']),
                          ].reduce((prev, curr) => [prev, ' ', curr])}
                        </Fragment>
                      )}
                      {log.issueLogs.mode ===
                        issueModes.processStatusSet.mode && (
                        <Fragment>
                          {[
                            ...(issueLogsContext.before
                              ? [
                                  <strong>จาก</strong>,
                                  <Chip
                                    className={classes.chipStatusSmallStyle}
                                    label={issueLogsContext.before.name}
                                    style={JSON.parse(
                                      issueLogsContext.before.style
                                    )}
                                  />,
                                ]
                              : ['']),
                            ,
                            ...(issueLogsContext.after
                              ? [
                                  <strong>เป็น</strong>,
                                  <Chip
                                    className={classes.chipStatusSmallStyle}
                                    label={issueLogsContext.after.name}
                                    style={JSON.parse(
                                      issueLogsContext.after.style
                                    )}
                                  />,
                                ]
                              : ['n/a']),
                          ].reduce((prev, curr) => [prev, ' ', curr])}
                        </Fragment>
                      )}
                      {log.issueLogs.mode === issueModes.issueLabelSet.mode && (
                        <Fragment>
                          {[
                            ...(issueLogsContext.remove.length
                              ? [
                                  <strong>นำออก</strong>,
                                  <ChipLabels
                                    labels={issueLogsContext.remove}
                                  />,
                                ]
                              : ['']), // Add [''] prevent error of Reduce of empty array with no initial value
                            ...(issueLogsContext.add.length
                              ? [
                                  <strong>เพิ่ม</strong>,
                                  <ChipLabels labels={issueLogsContext.add} />,
                                ]
                              : ['']),
                          ].reduce((prev, curr) => [prev, ' ', curr])}
                        </Fragment>
                      )}
                      {log.issueLogs.mode ===
                        issueModes.issueDimensionSet.mode && (
                        <Fragment>
                          {issueLogsContext.after
                            .map((dimA, index) => {
                              let dimB = issueLogsContext.before[index];
                              return [
                                ...(dimB
                                  ? [
                                      `${dimA.name}`,
                                      <strong>จาก</strong>,
                                      dimB.levelName,
                                      `(${dimB.value})`,
                                    ]
                                  : [dimA.name]),
                                <strong>เป็น</strong>,
                                `${dimA.levelName} (${dimA.value})`,
                              ].reduce((prev, curr) => [prev, ' ', curr]);
                            })
                            .reduce((prev, curr) => [prev, ' ', curr])}
                        </Fragment>
                      )}
                      {log.issueLogs.mode === 'issueCommentCreate' && (
                        <Fragment>
                          {[
                            `ประเภท: ${issueLogsContext.commentType}`,
                            issueLogsContext.receiverType
                              ? `ผู้รับ: ${issueLogsContext.receiverType}`
                              : '',
                            `รายละเอียด:  ${issueLogsContext.detail}`,
                          ].reduce((prev, curr) => [prev, ' ', curr])}
                        </Fragment>
                      )}
                      {log.issueLogs.mode ===
                        issueModes.issueCommentEdit.mode && (
                        <Fragment>
                          {[
                            `ประเภท: ${issueLogsContext.before.commentType}`,
                            issueLogsContext.before.receiverType
                              ? `ผู้รับ: ${issueLogsContext.before.receiverType}`
                              : '',
                            ...(issueLogsContext.before
                              ? [
                                  <strong>จาก</strong>,
                                  `${issueLogsContext.before.detail}`,
                                ]
                              : ['']),
                            ...(issueLogsContext.after
                              ? [
                                  <strong>เป็น</strong>,
                                  `${issueLogsContext.after.detail}`,
                                ]
                              : ['']),
                          ].reduce((prev, curr) => [prev, ' ', curr])}
                        </Fragment>
                      )}
                    </Box>
                    <Box pt={1} pr={1}>
                      เมื่อ:{' '}
                      {formatDatetime({
                        datetime: log.issueLogs.createDate,
                      })}
                    </Box>
                  </Fragment>
                )}
              </Box>
            </Typography>
            <Divider />
          </div>
        );
      })}
    </div>
  );
});

export default withStyles(styles)(LogCard);
